/* eslint no-console: 0 */
import messages from './messages'
import convert from './convert'
import format from './format'

export function getMessage ({ to, unit }) {
  const supportedToUnits = Object.keys(messages)

  if (!supportedToUnits.includes(to + unit)) {
    return console.error(`Unable to find message for ${to} in ${unit} format`)
  }

  return messages[to + unit]
}

export function getValues ({ from, to, value, locale, digits, numberOptions, clockDisplay }) {
  let formattedValue = ''
  let convertedValue = null

  if (typeof value === 'number') {
    convertedValue = convert(value, { from, to })
    formattedValue = format(convertedValue, { locale, digits, numberOptions, clockDisplay })
  }

  return { formattedValue, convertedValue, value }
}

export function stripMessageHTML (message) {
  return message
    .replace('<span data-value>', '')
    .replace('<span data-unit>', '')
    .replace(/\<\/span\>/g, '')
}




// WEBPACK FOOTER //
// ./src/shared/units/util.js